(function () {
    'use strict';

    angular
            .module('caloappApp')
            .controller('HomeController', HomeController);

    HomeController.$inject = ['$scope', 'Principal', 'LoginService', '$state'];

    function HomeController($scope, Principal, LoginService, $state) {
        var vm = this;

        vm.account = null;
        vm.isAuthenticated = null;
        vm.login = LoginService.open;
        vm.register = register;

        // this boolean will indivate whether to perform a redirection when calling
        // getAccount method
        vm.performRedirection = false;

        $scope.$on('authenticationSuccess', function () {
            vm.performRedirection = true;
            getAccount();
        });

        getAccount();

        function getAccount() {
            Principal.identity().then(function (account) {
                vm.account = account;
                vm.isAuthenticated = Principal.isAuthenticated;

                if (vm.performRedirection && vm.account) {

                    // case the user has the role ROLE_ADMIN or ROLE_USERS_MANAGER
                    // we redirect him to the users manager screen
                    if (vm.account.authorities.indexOf('ROLE_ADMIN') >= 0 || vm.account.authorities.indexOf('ROLE_USERS_MANAGER') >= 0) {
                        $state.go('user-management', null, {reload: true});
                    }
                    // else we will redirect him to the calories screen
                    else {
                        $state.go('user-calories', {'username': vm.account.login});
                    }

                }

            });
        }
        function register() {
            $state.go('register');
        }
    }
})();
